"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateMessageCustomTagParser = exports.estimateMessageCustomTagButtonDefs = void 0;
var react_1 = __importDefault(require("react"));
var parser_builder_1 = require("./parser_builder");
exports.estimateMessageCustomTagButtonDefs = [
    {
        tagName: 'hk-bold',
        label: '太字',
        element: react_1.default.createElement("i", { className: "fa fa-bold estimateMessageCustomTag-HkBold_ButtonIcon" })
    },
    {
        tagName: 'hk-red',
        label: '赤字',
        element: react_1.default.createElement("span", { className: "estimateMessageCustomTag-HkRed_ButtonIcon" }, "A")
    },
    {
        tagName: 'hk-h1',
        label: '見出し1',
        element: react_1.default.createElement("i", { className: "fa fa-grip-lines" })
    },
    {
        tagName: 'hk-h2',
        label: '見出し2',
        element: react_1.default.createElement("i", { className: "fa fa-grip-lines" })
    },
    {
        tagName: 'hk-frame1',
        label: '注意事項枠',
        element: react_1.default.createElement("i", { className: "fa fa-exclamation-circle estimateMessageCustomTag-HkFrame1_ButtonIcon" })
    }
];
var parseDefs = [
    {
        tagName: 'hk-bold',
        mappedTag: {
            name: 'span',
            attributes: {
                class: 'estimateMessageCustomTag-HkBold_Tag'
            }
        }
    },
    {
        tagName: 'hk-red',
        mappedTag: {
            name: 'span',
            attributes: {
                class: 'estimateMessageCustomTag-HkRed_Tag'
            }
        }
    },
    {
        tagName: 'hk-h1',
        mappedTag: {
            name: 'span',
            attributes: {
                class: 'estimateMessageCustomTag-HkH1_Tag'
            }
        }
    },
    {
        tagName: 'hk-h2',
        mappedTag: {
            name: 'span',
            attributes: {
                class: 'estimateMessageCustomTag-HkH2_Tag'
            }
        }
    },
    {
        tagName: 'hk-frame1',
        mappedTag: {
            name: 'div',
            attributes: {
                class: 'estimateMessageCustomTag-HkFrame1_Tag'
            }
        }
    }
];
exports.estimateMessageCustomTagParser = (0, parser_builder_1.buildParser)(parseDefs);
